module.exports = __webpack_public_path__ + "public/img/logoOig.eab3dd5c.png";